import * as React from 'react';
import { type Category } from '@/types';

export interface CategoryCardProps {
  category: Category;
  onClick: (category: Category) => void;
  isSelected: boolean;
}

export interface CategorySummaryProps {
  category: Category;
}

function CategorySummary(props: CategorySummaryProps) {
  const { category } = props;

  if(category.children && category.children.length > 0) {
    return (<span className="text-md text-gray-500">{category.children.length} categories</span>);
  }
  return null;
}

export function CategoryCard(props: CategoryCardProps) {

  return (
    <div className={`category-card ${props.isSelected ? 'selected' : ''}`} onClick={() => props.onClick(props.category)}>
      <h3>{props.category.name}</h3>
      <CategorySummary category={props.category} />
    </div>
  )
}